import { SlidersHorizontal } from 'lucide-react';

interface SearchBarProps {
  onFilterClick?: () => void;
}

const SearchBar = ({ onFilterClick }: SearchBarProps) => {
  return (
    <button
      onClick={onFilterClick}
      className="w-full bg-background rounded-2xl px-5 py-4 shadow-sm flex items-center justify-between"
    >
      <div className="text-center flex-1">
        <p className="font-semibold text-primary font-heading">Nearby</p>
        <p className="text-sm text-muted-foreground">Monday • 5 hours</p>
      </div>
      <div className="w-10 h-10 flex items-center justify-center">
        <SlidersHorizontal className="w-5 h-5 text-muted-foreground" />
      </div>
    </button>
  );
};

export default SearchBar;
